<template>
  <div>
    <el-alert type="error" class="mb-5" v-if="messages" @close="onClose">
      <slot>
        <div v-for="(item, index) in messages" :key="index">
          {{ Array.isArray(item) ? item.join('') : item }}
        </div>
      </slot>
    </el-alert>
  </div>
</template>
<script>
  export default {
    props: ['messages'],
    methods: {
      onClose () {
        this.$emit('close');
      }
    }
  }
</script>
